import { css } from "@emotion/react";
import { CSS_MQ } from "../../styles/breakpoints";
import { ReactTFC } from "../../utils/fp/missing-ts-parts";
import React from "react";
import { VideoIconsRenderer } from "./video-icons";
import { Spinner } from "../_shared-components/ui-elements/Spinner";
import { SmallLoadingSpinner } from "../../routes/modal-loading-spinner";

export const VideoPlaybackControl: ReactTFC<{ state: "waiting" | "playing" | "paused" }> = props => {
  return (
    <React.Fragment>
      {props.state === "paused" ? (
        <VideoIconsRenderer icon={"PlayCircleSvgIcon"} className={"progress-icon play"} css={iconStyles} />
      ) : props.state === "playing" ? (
        <VideoIconsRenderer icon={"PauseCircleSvgIcon"} className={"progress-icon pause"} css={iconStyles} />
      ) : (
        <SmallLoadingSpinner className={"waiting"} size={"3x"} />
      )}
    </React.Fragment>
  );
};
const iconStyles = css`
  width: 50px;
  height: 50px;

  ${CSS_MQ.atLeastMd} {
    width: 70px;
    height: 70px;
  }
`;
